import { Button, message } from "antd";
import { FormEvent } from "react";
import { createPOF } from "../../../apis/misc.api";
import { usePermissions } from "../../../custom_hooks/permission/permission_hook";

export interface AttachPODDrawerProps {
  delivery: any;
  onClose: () => void;
}

export function AttachPODDrawer({ delivery, onClose }: AttachPODDrawerProps) {
  const { hasPermission } = usePermissions();
  const canEdit = hasPermission("delivery.update");
  const onSubmit = async (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    if (!canEdit) {
      message.error("You don't have permission to attach POD");
      return;
    }

    const formData = new FormData(ev.currentTarget);
    const files = formData.getAll('proof_files');
    if (files.length === 0) {
      message.error("Please select at least one file");
      return;
    }
    formData.append('po_delivery_id', delivery.id.toString());
    formData.append('fullfillment_type', 'Delivery');

    const result = await createPOF(formData);

    if (result) {
      message.success("POD attached successfully");

      // Close the drawer
      onClose();
    } else {
      message.error("Failed to attach POD");
    }
  };

  return (
    <div>
      <form onSubmit={onSubmit}>
        <div className="mb-3">
          <input type="file" name="proof_files" id="proof_files"
            multiple className="form-control" accept="image/*,application/pdf"/>
        </div>
        <Button htmlType="submit" type="primary" disabled={!canEdit}>
          Submit
        </Button>
      </form>
    </div>
  );
}
